import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
export default {
	init() {
		let init = false;
		let swiper;
		const accordionDetails = document.querySelectorAll('.accordion-item');
		const accordionSwiper = document.querySelector('.accordion-swiper');
		let openAllRaf = 0;

		if (!accordionDetails.length) return;

		function setAllOpen(open) {
			accordionDetails.forEach((item) => {
				item.open = Boolean(open);
			});
		}

		function detailsClickBlocker(event) {
			event.preventDefault();
		}

		function disableDetailsGrouping() {
			accordionDetails.forEach((item) => {
				const name = item.getAttribute('name');
				if (name && !item.dataset.originalDetailsName) {
					item.dataset.originalDetailsName = name;
				}
				item.removeAttribute('name');
				item.addEventListener('click', detailsClickBlocker);
			});
		}

		function restoreDetailsGrouping() {
			accordionDetails.forEach((item) => {
				const original = item.dataset.originalDetailsName;
				if (original) item.setAttribute('name', original);
				item.removeEventListener('click', detailsClickBlocker);
			});
		}

		function addSwiper() {
			if (window.innerWidth <= 768) {
				// <details name="..."></details> enforces a single-open group.
				// Remove that grouping on mobile so we can open all items.
				disableDetailsGrouping();
				// Some browsers keep the "group" behavior for the current frame even after
				// removing the name attribute; opening in a loop then leaves only the last
				// item open. Defer to the next frame so the DOM attribute change is applied.
				if (openAllRaf) cancelAnimationFrame(openAllRaf);
				openAllRaf = requestAnimationFrame(() => setAllOpen(true));

				if (!init && accordionSwiper) {
					const paginationEl = accordionSwiper.querySelector('.swiper-pagination');
					swiper = new Swiper(accordionSwiper, {
						modules: [Navigation, Pagination],
						slidesPerView: 1,
						autoHeight: true,
						pagination: {
							el: paginationEl,
							type: 'progressbar',
						},
						navigation: {
							nextEl: accordionSwiper.querySelector('.swiper-button-next'),
							prevEl: accordionSwiper.querySelector('.swiper-button-prev'),
						},
					});
					init = true;
				}
			} else if (init) {
				if (openAllRaf) cancelAnimationFrame(openAllRaf);
				openAllRaf = 0;
				if (swiper) swiper.destroy(true, true);
				swiper = undefined;
				init = false;

				restoreDetailsGrouping();
				setAllOpen(false);
				accordionDetails[0].open = true;
			}
		}

		addSwiper();
		window.addEventListener('resize', addSwiper);
	},
};
